import { render } from "./lessonContent.vue?vue&type=template&id=07bf9dfc&scoped=true"
import script from "./lessonContent.vue?vue&type=script&lang=js"
export * from "./lessonContent.vue?vue&type=script&lang=js"

import "./lessonContent.vue?vue&type=style&index=0&id=07bf9dfc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07bf9dfc"]])

export default __exports__